'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgShield(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M7.467 2.196L3.65 3.893C3.256 4.067 3 4.46 3 4.89v2.564C3 10.482 5.095 13.313 7.91 14c2.814-.687 4.908-3.518 4.908-6.545V4.89c0-.431-.256-.824-.649-.998L8.351 2.196a1.084 1.084 0 00-.884 0zm.442 5.799h3.818c-.289 2.247-1.789 4.249-3.818 4.876V8H4.091V4.89l3.818-1.695v4.8z", fill: "currentColor" }))));
}

module.exports = SvgShield;
//# sourceMappingURL=Shield.js.map
